module.exports = __webpack_public_path__ + "static/media/europeana_artist_app.6ce7586e.jpg";